// Style imports.
import "normalize.css";
import "../../css/main.css";

// React imports.
import React from "react";
import ReactDOM from "react-dom/client";

// App imports.
import BaseLayout from "./components/BaseLayout";
import * as utility from "./utility";
import * as worker from "../baseWorker";
import { IFiscalYear } from "../baseWorker";

const baseComponentRef = React.createRef<BaseLayout>();
const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
     <BaseLayout ref={baseComponentRef} />
);

// React 18+: createRoot renders asynchronously. Poll for the ref to be populated
// before bootstrapping (a single setTimeout(0) can fire before commit).
function waitForMount(attempt = 0) {
     if (!baseComponentRef.current) {
          if (attempt > 50) {
               console.error("BaseLayout component not mounted yet");
               return;
          }
          setTimeout(() => waitForMount(attempt + 1), 20);
          return;
     }
     const baseComponent = baseComponentRef.current!;

     //display the wait message
     baseComponent.state.showSpinner();
     sessionStorage.clear();

     //get the current user info
     async function getUserInfo() {
          const userWorker: worker.baseWorker = new worker.baseWorker();
          try {

               const currentUser: worker.IUserInfo = await userWorker.getUserInfo();
               baseComponent.state.setCurrentUserInfo(currentUser);
          }
          catch (err) {
               console.log(err);
               baseComponent.state.showError(err.message);
               throw Error("Failed to get user info.");
          }
     }

     //get grantees
     async function getGrantees() {
          const granteeWorker: worker.baseWorker = new worker.baseWorker();
          try {

               const grantees: worker.IGrantee[] = await granteeWorker.getGrantees();
               baseComponent.state.setGrantees(grantees);
          }
          catch (err) {
               console.log(err);
               baseComponent.state.showError(err.message);
               throw Error("Failed to get grantees.");
          }
     }

     async function getFiscalYears() {
          const fiscalYearWorker: worker.baseWorker = new worker.baseWorker();
          try {

               const fiscalYears: worker.IFiscalYear[] = await fiscalYearWorker.getFiscalYears();
               baseComponent.state.setFiscalYears(fiscalYears);
          }
          catch (err) {
               console.log(err);
               baseComponent.state.showError(err.message);
               throw Error("Failed to get grantees.");
          }
     }
     const yearsPromise = getFiscalYears();
     const granteesPromise = getGrantees();
     const userPromise = getUserInfo();
     Promise.all([granteesPromise, userPromise, yearsPromise])
          .then((values) => {

               //set SelectedGranteeIds to grantees in user region
               baseComponent.state.setGranteeArrayToRegion();

               baseComponent.state.hideSpinner();
          }
     );
}
waitForMount();
